module.exports = __webpack_public_path__ + "iconfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/packages/button/iconfont.woff?t=1564473778850
// module id = 27
// module chunks = 0